<ion-icon name="moodle-swipe-navigation" aria-hidden="true" />
<p>{{ 'core.swipenavigationtourdescription' | translate }}</p>
<ion-button (click)="dismiss()" expand="block" fill="outline">
    {{ 'core.endonesteptour' | translate }}
</ion-button>
